'use client';

import { useBiblePrefetch } from '@/hooks/use-bible-prefetch';

export function BiblePrefetchProvider({ children }: { children: React.ReactNode }) {
  useBiblePrefetch();
  return <>{children}</>;
}
